import { NOMINEE_SHAREHOLDER } from "@/constants/config";

/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/prefer-default-export
export const transformNomineeShareholder = obj => {
    if(obj.nominatorType.text === NOMINEE_SHAREHOLDER.NOMINATOR.TYPE.INDIVIDUAL && obj.alias) {
        obj.alias = obj.alias.toUpperCase();
    }

    if(obj.nominatorType.text === NOMINEE_SHAREHOLDER.NOMINATOR.TYPE.CORPORATE) {
        obj.uen = obj.uen.toUpperCase();
    }
    
    // if new nominator then need transform to uppercase
    if(! obj.isExistingNominator) {
        obj.nominator.nric = obj.nominator.nric.toUpperCase();
        obj.nominator.name = obj.nominator.name.toUpperCase();
        if(obj.nominatorType.text === NOMINEE_SHAREHOLDER.NOMINATOR.TYPE.INDIVIDUAL) {
            obj.nominator.alias = obj.nominator?.alias?.toUpperCase();
        }
        obj.nominator.email = obj.nominator?.email?.toUpperCase();
        obj.nominator.address = obj.nominator.address.toUpperCase();
    }
    return obj;
};